import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsBrandManagementTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.brand-management')} />
      <IntegrationsTable category={IntegrationCategory.BRAND_MANAGEMENT} />
    </section>
  );
};

export default IntegrationsBrandManagementTab;
